export default {
  '--intergalactic-bg-primary-feature-highlight': '#ffffff',
  '--intergalactic-bg-primary-feature-highlight-hover-active': 'linear-gradient(90deg, #f9f2ff, #e9f7ff)',
  '--intergalactic-bg-secondary-feature-highlight': 'linear-gradient(90deg, #f9f2ff, #e9f7ff)',
  '--intergalactic-border-feature-highlight': 'linear-gradient(90deg, #c695ff, #2bb3ff)',
  '--intergalactic-border-feature-highlight-active': 'linear-gradient(90deg, #ab6cfe, #008ff8)',
  '--intergalactic-border-feature-highlight-secondary': 'linear-gradient(90deg, #dcb8ff, #8ecdff)',
  '--intergalactic-control-primary-feature-highlight': 'linear-gradient(90deg, #ab6cfe, #008ff8)',
  '--intergalactic-control-primary-feature-highlight-hover': 'linear-gradient(90deg, #8649e1, #006dca)',
  '--intergalactic-control-primary-feature-highlight-active': 'linear-gradient(90deg, #5925ab, #044792)',
  '--intergalactic-control-secondary-feature-highlight': 'linear-gradient(90deg, #f9f2ff, #e9f7ff)',
  '--intergalactic-control-secondary-feature-highlight-hover': 'linear-gradient(90deg, #f2e4ff, #d6edfe)',
  '--intergalactic-control-secondary-feature-highlight-active': 'linear-gradient(90deg, #edd9ff, #c4e5fe)',
  '--intergalactic-text-feature-highlight': 'linear-gradient(90deg, #8649e1, #006dca)',
  '--intergalactic-text-feature-highlight-hover-active': 'linear-gradient(90deg, #421983, #002b5f)',
  '--intergalactic-icon-primary-feature-highlight': '#8649e1',
  '--intergalactic-icon-primary-feature-highlight-hover-active': '#6B3AB4',
  '--intergalactic-keyboard-focus-feature-highlight-outline': 'linear-gradient(90deg, #ab6cfe, #008ff8)',
};
